<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="tabChanged($event.index)">
        <mat-tab label="Proposer Details" [disabled]="isTabLocked(0)">
          <app-ag-proposer-details [staticData]="staticData" [modelObj]="modelObj" [authDetails]="authDetails"
            [apiModelObj]="apiModelObj" [quote_type]="quote_type"
            (isFleetActivated)="is_fleet($event)"
            (modelObjUpdated)="modelObjUpdated($event)"></app-ag-proposer-details>
        </mat-tab>
        <mat-tab label="Fleet Experience" *ngIf="isFleetActivated" [disabled]="isTabLocked(fleetTabIndex)">
          <app-ag-fleet-experience [staticData]="staticData" [modelObj]="modelObj" [authDetails]="authDetails"
            [apiModelObj]="apiModelObj"
            (tabChanged)="tabChanged($event)"
            (modelObjUpdated)="modelObjUpdated($event)"></app-ag-fleet-experience>
        </mat-tab>
        <mat-tab label="Vehicles" [disabled]="isTabLocked(vehiclesTabIndex)">
          <app-ag-vehicles [staticData]="staticData" [modelObj]="modelObj" [authDetails]="authDetails"
            [apiModelObj]="apiModelObj"
            (tabChanged)="tabChanged($event)"
            (modelObjUpdated)="modelObjUpdated($event)"></app-ag-vehicles>
        </mat-tab>
        <mat-tab label="Drivers" [disabled]="isTabLocked(driversTabIndex)">
          <app-ag-drivers [staticData]="staticData" [modelObj]="modelObj" [authDetails]="authDetails"
            [selectedIndex]="selectedIndex" [apiModelObj]="apiModelObj"
            (modelObjUpdated)="modelObjUpdated($event)"></app-ag-drivers>
        </mat-tab>
        <mat-tab label="Quotation" [disabled]="isTabLocked(quotationTabIndex)">
          <app-ag-quotation [staticData]="staticData" [authDetails]="authDetails" [modelObj]="modelObj"
            (modelObjUpdated)="modelObjUpdated($event)" [apiModelObj]="apiModelObj"
            [selectedIndex]="selectedIndex"></app-ag-quotation>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
